import { autditTrails, ftUrls, FT_KEY, VERSION } from "../../constants/ApiUrls";
import {
  getData,
  postData,
  updateData,
} from "../../networkManager/NetworkManager";

export const getRelationshipList = async () => {
  return await getData(FT_KEY + VERSION + ftUrls.GET_RELATIONSHIP_LIST);
};

export const getFamilyTree = async (id) => {
  let url =
    FT_KEY + VERSION + `${id}/${ftUrls.GET_FAMILY_TREE}?onlyPercentage=true`;
  return await getData(url);
};

export const addFamilyMember = async (id, data) => {
  let url = FT_KEY + VERSION + `${id}/${ftUrls.ADD_MEMBER}`;

  return await updateData(url, data);
};

export const uploadProfilePicture = async (id, data) => {
  let url = FT_KEY + VERSION + `${id}/${ftUrls.ADD_PROFILE_PICTURE}`;

  return await postData(url, data);
};

export const getMarriageTypes = async (id) => {
  let url = FT_KEY + VERSION + `${ftUrls.GET_MARRIAGE_TYPES}`;

  return await getData(url);
};

export const getTotalAuditTrials = async (id) => {
  let url = FT_KEY + VERSION + `familyTree/${id}/${autditTrails.AUDIT_TRAIL}`;
  return await getData(url);
};

export const updateAuditTrials = async (id, dataObj) => {
  let url =
    FT_KEY + VERSION + `familyTree/${id}/${autditTrails.INACTIVE_AUDIT_TRAILS}`;
  return await updateData(url, dataObj);
};
